module.exports = __webpack_public_path__ + "img/dog-tunnel.31be9de.svg";